export default {
      id: "btn-square-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#btn-square-usage",
      toString: function () {
        return this.url;
      }
    }